async function allSettled(promises) {
    if (typeof promises[Symbol.iterator] !== "function") {
        throw new Error("Object passed to allSettled is not iterable");
    }
    const mappedPromises = promises.map((p) => {
        if (p instanceof Promise) {
            return p
                .then((value) => {
                return {
                    status: "fulfilled",
                    value,
                };
            })
                .catch((reason) => {
                return {
                    status: "rejected",
                    reason,
                };
            });
        }
        return p;
    });
    return Promise.all(mappedPromises);
}
export default allSettled;
//# sourceMappingURL=all-settled.js.map